/**
 * Set default props for the currency input
 *
 */
function formkitCurrencyInputPlugin(node: any) {
  if (node.props.type === 'currency') {
    node.props.currency = 'AUD';
    node.props.displayLocale = 'en-AU';
    node.props.validationRules = { ...node.props.validationRules, noDecimals };
  }
}

function noDecimals(node: any) {
  return node.value ? node.value.toString().indexOf('.') === -1 : true;
}

export default formkitCurrencyInputPlugin;
